import { SisCaregiver, SisStudentDetails } from '../../../RiderCreationModal/SisImportBanner/types';
import { ContactFormValue } from '../../types';

export const mapSisStudentToBasicInfoFields = (sisData: SisStudentDetails) => ({
  firstName: sisData.firstName,
  lastName: sisData.lastName,
  email: sisData.email || '',
  externalId: sisData.identifier,
});

// PhoneNumberInput (@hopskipdrive/react-components) expects a bare 10-digit initialValue —
// SIS caregiver phone numbers come formatted (e.g. "555-123-4567"), which the component
// mis-masks, dropping a digit. Strip everything but digits before handing it to the form.
const stripNonDigits = (phoneNumber: string): string => phoneNumber.replace(/\D/g, '');

export const mapSisCaregiversToContacts = (caregivers: SisCaregiver[]): ContactFormValue[] =>
  caregivers.map((caregiver) => ({
    firstName: caregiver.firstName,
    lastName: caregiver.lastName,
    role: 'caregiver',
    relationship: '',
    phoneNumber: caregiver.phone ? stripNonDigits(caregiver.phone) : '',
    email: caregiver.email || '',
  }));
